import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import {YeuCauXuatKhanModel } from '../yeu-cau-xuat-khan-model/yeu-cau-xuat-khan.model';
import {YeuCauXuatKhan_CtModel } from '../yeu-cau-xuat-khan-model/yeu-cau-xuat-khan.model';

const API_ROOT_URL = environment.ApiRoot + '/yeucauxuatkhan';

@Injectable()
export class YeuCauXuatKhanService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'desc', 'ThoiGianTao', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	detail(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/Detail?Id=${itemId}`,  { headers: httpHeaders} );
	}
	deleteYeuCauXuatKhan(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/Delete?Id=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteYeuCauXuatKhans(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createYeuCauXuatKhan(item:any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauXuatKhanModel>(API_ROOT_URL+'/Insert', item, { headers: httpHeaders });
	}
	updateYeuCauXuatKhan(item:any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauXuatKhanModel>(API_ROOT_URL+'/Update', item, { headers: httpHeaders });
	}
    //#region ***filter***
    getFilterGroup(column: string, url: string): Observable < any > {
        return this.http.get<any>(environment.ApiRoot + url + `${column}`);
    }
	uploadFileYeuCauXuatKhan(data:any): Observable<any> {
		const url = API_ROOT_URL + '';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importYeuCauXuatKhan(item:any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauXuatKhanModel>(API_ROOT_URL+'', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + ``;
	}

	accept(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/Confirm', data , {
			headers: httpHeaders
		});
	}

	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/Cancel?Id=${itemId}`,  { headers: httpHeaders} );
	}

	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/Delete?Id=${itemId}`,  { headers: httpHeaders} );
	}

	FindDataLotDNXK(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/FindDataLotDNXK', data , {headers: httpHeaders});
	}

	insertPKTPK(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/InsertPKT', data , {headers: httpHeaders});
	}

	getDetailPKTPK(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/PhieuKiemTraPassKhan_Get_Detail?Id=${itemId}`,  { headers: httpHeaders} );
	}

	listHangHoa_id() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		
			const url =  environment.ApiRoot + '/' ;
		
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	// Tạo Pass Khẩn cho BTP
	insert_pk_btp(item:any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/insert_pk', item, { headers: httpHeaders });
	}

	detail_pk_btp(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/detail_pk?Id=${itemId}`,  { headers: httpHeaders} );
	}

	accept_pk_btp(data: any){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/confirm_pk', data , {
			headers: httpHeaders
		});
	}

	get_mers_of_type(type : string){
		const API_ROOT_URL_DANHMUC = environment.ApiRoot + '/danhmuc';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL_DANHMUC + `/ListMerchandisesOfType?loai_hang_hoa=${type}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
